import { createCustomAction } from 'typesafe-actions';
import { ENTITY_CONCEPT_EXPRESSIONS_GENERATED } from './constants';
import { EntityFieldConceptExps } from './reducer';

export const entityConceptExpressionsGenerated = createCustomAction(ENTITY_CONCEPT_EXPRESSIONS_GENERATED, type => {
    return (payload: EntityFieldConceptExps) => ({ type, payload });
});
